import { Routes, Route, Navigate } from "react-router-dom";
import { DataProvider, useSettings } from "./lib/data.tsx";
import { ScrollToTop } from "./components/ScrollToTop.tsx";
import { ThemeToggle } from "./components/atoms/ThemeToggle.tsx";
import { Footer } from "./components/organisms/Footer.tsx";
import { CommandPalette } from "./components/organisms/CommandPalette.tsx";
import { EntryModal } from "./components/molecules/EntryModal.tsx";
import { LegacyRitualRedirect } from "./lib/legacyRedirect.tsx";
import { HomePage } from "./pages/HomePage.tsx";
import { VaultPage } from "./pages/VaultPage.tsx";
import { PromptsPage } from "./pages/PromptsPage.tsx";
import { RitualPage } from "./pages/RitualPage.tsx";
import { ProjectsPage } from "./pages/ProjectsPage.tsx";
import { WhatsNewPage } from "./pages/WhatsNewPage.tsx";

function Shell() {
  const settings = useSettings();

  return (
    <div className="app-shell">
      <ThemeToggle />
      <CommandPalette />
      <div className="app-main">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/vault" element={<VaultPage />}>
            <Route path=":slug" element={<EntryModal type="vault" listPath="/vault" />} />
          </Route>
          <Route path="/prompts" element={<PromptsPage />}>
            <Route path=":slug" element={<EntryModal type="prompt" listPath="/prompts" />} />
          </Route>
          <Route path="/ritual" element={<RitualPage />} />
          <Route path="/ritual/view" element={<LegacyRitualRedirect />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/whats-new" element={<WhatsNewPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
      <Footer note={settings.value.footerNote} />
    </div>
  );
}

export default function App() {
  return (
    <DataProvider>
      <ScrollToTop />
      <Shell />
    </DataProvider>
  );
}
